import uuid from 'uuid/v4';
import * as R from 'ramda';
import { multipleChoiceData } from './multipleChoice';
import { paragraphData } from './paragraph';
import { titleDescriptionData } from './titleDescription';
import { textData } from './text';
import { fieldNames } from '.';
import { checkboxData } from './checkbox';
import { dropdownData } from './select';
import { linearScaleData } from './linearScale';
import { dividerData } from './divider';
import { dateData } from './date';
import { timeData } from './time';
import { richContentData } from './richContent';
import { pageBreakData } from './pageBreak';

const newFieldMap = {
    [fieldNames.select]: dropdownData,
    [fieldNames.checkbox]: checkboxData,
    [fieldNames.multipleChoice]: multipleChoiceData,
    [fieldNames.paragraph]: paragraphData,
    [fieldNames.title]: titleDescriptionData,
    [fieldNames.text]: textData,
    [fieldNames.linearScale]: linearScaleData,
    [fieldNames.divider]: dividerData,
    [fieldNames.date]: dateData,
    [fieldNames.time]: timeData,
    [fieldNames.richContent]: richContentData,
    [fieldNames.pageBreak]: pageBreakData
};

export const generateNewField = (value) => {
    const id = uuid();
    const { dataModel, defaults } = newFieldMap[value];
    return R.mergeAll([dataModel, defaults, { id }]);
};

